export const BASE_URL = "https://api.mvpfcompare.com/";
